import {
    CURRENT_APP_GROWAVE,
    CURRENT_APP_QUERY_PARAMETER,
    GROWAVE_TOKEN_STRATEGY,
    TOKEN_STRATEGY_QUERY_PARAMETER,
} from "@/constants/current_app";
import type TokenManagerInterface from "@modules/token_manager/TokenManager/TokenManagerInterface";

import {
    EARNING_RULE_SHARE_EVENT_TYPE,
    EARNING_RULE_SHARE_RULE_ID,
    REFERRAL_SHARE_CHANNELTYPE,
    REWARDS_STOREFRONT_BASE_URL,
    SOCIAL_SHARE_CHANNELNAME,
    TOKEN,
} from "../constants/constants";
import type { REWARDS_EARNING_RULE_SHARE_CONFIG } from "../modules/EarningRules/types";
import type { ReferralShareConfig } from "../types";

/**
 * Function for getting share url.
 * @param {string} shareType
 * @param {ReferralShareConfig | REWARDS_EARNING_RULE_SHARE_CONFIG} config
 */
export const getShareUrl = (
    shareType: string,
    config: ReferralShareConfig | REWARDS_EARNING_RULE_SHARE_CONFIG,
    tokenManager: TokenManagerInterface
) => {
    const shareUrl = `${REWARDS_STOREFRONT_BASE_URL}/${shareType}/share`;
    const url = new URL(shareUrl);
    const searchParams = new URLSearchParams();

    //add x-gw-current-app
    searchParams.set(CURRENT_APP_QUERY_PARAMETER, CURRENT_APP_GROWAVE);
    //add token strategy
    searchParams.set(TOKEN_STRATEGY_QUERY_PARAMETER, GROWAVE_TOKEN_STRATEGY);
    //add token
    const token = tokenManager.getToken();

    if (token) {
        searchParams.set(TOKEN, token);
    }

    if ("channelType" in config) {
        searchParams.set(REFERRAL_SHARE_CHANNELTYPE, config.channelType);
    } else {
        searchParams.set(EARNING_RULE_SHARE_RULE_ID, config.ruleId.toString());
        searchParams.set(EARNING_RULE_SHARE_EVENT_TYPE, config.eventType);
    }

    if ("channelName" in config && config.channelName) {
        searchParams.set(SOCIAL_SHARE_CHANNELNAME, config.channelName);
    }

    url.search = searchParams.toString();
    return url.toString();
};
